module.exports = __webpack_public_path__ + "DINNextLTPro-Bold.eot?1adc611d01bb65b9156b3c2b1b2ef9a5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-Bold.eot
// module id = 315
// module chunks = 0